import { addDays, format, isValid, parseISO, subDays } from "date-fns";
import DATE_FORMAT from "../../config/date-config";

export const todayDate = (formatStr = DATE_FORMAT.DATE) => {
    return format(new Date(), formatStr);
}

export const getTomorrowDate = (date, formatStr = DATE_FORMAT.DATE) => {
    const baseDate = date ? new Date(date) : new Date();
    return format(addDays(baseDate, 1), formatStr);
};

export const getYesterDayDate = (date, formatStr = DATE_FORMAT.DATE) => {
    const baseDate = date ? new Date(date) : new Date();
    return format(subDays(baseDate, 1), formatStr);
};

export const getFormattedDate = (dateInput, formatStr = DATE_FORMAT.DATE) => {
    // Handle null/undefined inputs
    if (dateInput == null) return "";
    const date = typeof dateInput === "string" ? parseISO(dateInput) : new Date(dateInput);
    return isValid(date) ? format(date, formatStr) : "";
};

export const getFormattedDateTime = (dateTimeInput, formatStr = DATE_FORMAT.DATE_WITH_TIME_S) => {
    // Handle null/undefined inputs
    if (dateTimeInput == null) return "";
    const dateTime = typeof dateTimeInput === "string" ? parseISO(dateTimeInput) : new Date(dateTimeInput);
    return isValid(dateTime) ? format(dateTime, formatStr) : "";
};